import { useInView } from "../../hooks/useInView";

export function AnimatedListItem({ children, delay = 0 }) {
  const [ref, inView] = useInView(0.1);
  return (
    <li ref={ref} style={{ opacity: inView ? 1 : 0, transform: inView ? "translateX(0px)" : "translateX(-28px)", transition: `opacity 0.5s ease ${delay}ms, transform 0.5s cubic-bezier(0.22,1,0.36,1) ${delay}ms` }}>
      {children}
    </li>
  );
}
